import oneNote from '../../assets/images/file_icons/one-note.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";
export var OneNote = function OneNote(_ref) {
  var onenote_url = _ref.onenote_url;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "card mb-0 mt-3 border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between pt-1 align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-4"
  }, /*#__PURE__*/React.createElement("img", {
    src: oneNote,
    height: 40,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "mb-0 fw-1 truncate"
  }, "One Note Document"))), /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("a", {
    href: onenote_url,
    target: "_blank",
    className: "btn btn-nurture-purple me-1 w-100 w-sm-200px d-inline-block"
  }, "Open in Onenote", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faExternalLinkSquareAlt,
    className: "ms-2"
  }))))));
};
export default OneNote;